/* eslint no-undef: 0 */
import React, { useState } from 'react'
import { SimulationFlow } from '@webmotors/financing-lib'
import {
  floatToCurrency,
  createCookieBig,
  getCurrentChannel,
  sendDispatchEvent,
  sendPageInteraction,
  PAGE_INTERACTION_EVENTS,
  getDataLayerUrl,
  createUrlIdc,
  onClientSide,
} from '@/utils/utils'
import { COOKIES, CHANNEL, SYSTEM, AD_TYPE } from 'utils/constants'
import {
  cookieCategoryIsActive,
  getEncryptedCookie,
  setEncryptedCookie,
} from '@/modern/utils/cookies'
import useBlackFair from '@/modern/hooks/useBlackFair'
import {
  getFBCLIDFromUrl,
  getGCLIDFromUrl,
  getMCMIDFromCookie,
} from '@/modern/hooks/useTargetApi/getVisitorData'
import { useTargetApi as targetApi } from '@/modern/hooks/useTargetApi'
import { config } from '../../../config/config'

const defaultPhoto =
  'https://webmotors.com.br/assets/img/webp/vehicle_no_photo.webp?t=1.0.1'

const PERSON_TYPE = {
  PJ: 2,
  PF: 1,
}

const VEHICLE_TYPE = {
  CAR: 4,
  MOTO: 5,
}

const OFFERS_TYPE = {
  YES: 1,
  NO: 2,
}

const INTEREST_TYPE = {
  YES: 1,
  NO: 2,
}

const CARDELIVERY_TYPE = {
  YES: 1,
  NO: 2,
}

const EXPIRE_TIME = 0.3

const EVENT_AB_TEST_KEYS = {
  ver_parcelas_antes_modal_avisar_financiamento: [
    'simulationResultLib',
    'skipSimulationResult',
  ],
  teste_analytics_dash_pap_reversao_pos_negado: [
    'reversalDeniedRecomendations',
  ],
}

const SimulationSantanderLib = ({
  photos,
  dataForm,
  cookies,
  ad,
  isPJ,
  sellerType,
  isRecapture,
  location,
}) => {
  const [newsletter, setNewsletter] = useState(false)

  const blackFair = useBlackFair()

  const getChannel = () => {
    const channel = cookieCategoryIsActive(cookies, COOKIES.CHANNEL)

    let prepareChannel = CHANNEL.WEBMOTORS

    const cookieChannel = channel && getCurrentChannel()

    const params = getDataLayerUrl(location)
    if (params.hd) {
      prepareChannel = CHANNEL.FEIRAO
    } else if (cookieChannel) {
      if (cookieChannel === SYSTEM.MEUCARANGO)
        prepareChannel = CHANNEL.MEUCARANGO
      else if (cookieChannel === SYSTEM.COMPREAUTO)
        prepareChannel = CHANNEL.COMPREAUTO
      else if (cookieChannel === SYSTEM.ITAJAICARROS)
        prepareChannel = CHANNEL.ITAJAICARROS
      else if (cookieChannel === SYSTEM.FLORIPACARROS)
        prepareChannel = CHANNEL.FLORIPACARROS
      else if (cookieChannel === SYSTEM.BLUCARROS)
        prepareChannel = CHANNEL.BLUCARROS
      else if (cookieChannel === SYSTEM.JOINVILLECARROS)
        prepareChannel = CHANNEL.JOINVILLECARROS
    }

    return prepareChannel
  }

  const getAdobeGuid = () => {
    let adobeGuid = null
    if (
      process.env.NODE_ENV !== 'development' &&
      typeof Visitor !== 'undefined' &&
      Visitor != null &&
      Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') !== null &&
      Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') !== undefined &&
      Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID() != null &&
      Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID() !== undefined
    ) {
      adobeGuid = Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID()
    }

    if (!adobeGuid) {
      adobeGuid = getMCMIDFromCookie()
    }

    return adobeGuid
  }

  const prepareImages = photos.length === 0 ? [defaultPhoto] : photos

  const VEHICLE_DETAILS = {
    adapted: false, // fixo
    taxi: false, // fixo
    purchaseValue: dataForm.price,
    vehicleTypeId:
      dataForm.vehicleType === 'car' ? VEHICLE_TYPE.CAR : VEHICLE_TYPE.MOTO,
    year: `${dataForm.yearFabrication}/${dataForm.yearModel}`,
    address: `${ad.Seller.City} - ${ad.Seller.State.split(' ')
      .pop()
      .replace(/[()]/g, '')}`,
    km: ad.Specification.Odometer
      ? floatToCurrency(parseFloat(ad.Specification.Odometer), 0)
      : '0',
    images: !prepareImages[0].urlMedium
      ? [defaultPhoto]
      : prepareImages.map(elm => elm.urlMedium),
  }

  const VEHICLE_DATE = {
    marca: dataForm.make,
    modelo: dataForm.model,
    ano: dataForm.yearModel,
    versao: dataForm.version ? dataForm.version : '',
    vehicleType: dataForm.vehicleType === 'car' ? 'Carro' : 'Moto',
  }
  const fbclid = getFBCLIDFromUrl(onClientSide() ? window.location.search : '')
  const gclid = getGCLIDFromUrl(onClientSide() ? window.location.search : '')

  const ANNOUNCEMENT_DATA = {
    isPJ,
    DonoVeiculo: isPJ ? 'PJ' : 'PF',
    TipoPessoa: isPJ ? PERSON_TYPE.PJ : PERSON_TYPE.PF,
    CNPJ: isPJ ? dataForm.storeDocument : null,
    dealership: dataForm.sellerId,
    dealershipName: dataForm.storeName,
    C2C: !isPJ,
    idAnuncio: dataForm.uniqueId,
    CanalApp: isRecapture ? 7 : 1,
    leadChanel: getChannel(),
    adobeGuid: getAdobeGuid(),
    IdGuid: dataForm.idGuid,
    TipoAnuncio: dataForm.listingType === AD_TYPE.NEW ? 'Novos' : 'Usados',
    TipoVeiculo: dataForm.vehicleType,
    hyundaiGroup: ad.Seller.HyundaiGroup || false,
    hyundaiGroupCNPJ: ad.Seller.HyundaiGroupCNPJ,
    Origem: ad.Seller.HyundaiGroup ? 'hyundai' : '',
    IdNegociacao: 0, // Fixo,
    seller: ad.Seller || undefined,
    FBCLID: fbclid,
    GCLID: gclid,
  }

  const STORE_DATA = { name: '', tabId: 0 }

  const createFinancingLeadCookie = data => {
    const defaultCookie = { Principal: {}, Details: {} }
    setNewsletter(data.newsletter)

    const cookieData = getEncryptedCookie(COOKIES.FORM_DATA) || defaultCookie

    const newCookieData = {
      ...cookieData,
      Principal: {
        ...cookieData.Principal,
        email: data.email,
        fullName: data.fullName,
        numberPhone: data.phone,
      },
      Details: {
        ...cookieData.Details,
        birthday: data.date,
        cpf: data.cpf,
        location: data.state.value,
        newsletter: data.newsletter,
        vehicleInterest: false,
        leadSeeInstallments: data.leadSeeInstallments,
      },
    }

    setEncryptedCookie(COOKIES.FORM_DATA, newCookieData)
  }

  const getLeadCookie = () => {
    const cookieData = getEncryptedCookie(COOKIES.FORM_DATA)

    if (!cookieData) return {}

    const { email, fullName, numberPhone } = cookieData.Principal

    return {
      email,
      fullName,
      phone: numberPhone,
    }
  }

  const updateObjDatalayer = ({
    leadSeeInstallments,
    simulation,
    errorDescription = undefined,
    errorID = undefined,
  }) => {
    const prepareObjDataLayer = objDataLayer || {}
    prepareObjDataLayer.conversion = prepareObjDataLayer.conversion || {}
    prepareObjDataLayer.conversion.financing =
      prepareObjDataLayer.conversion.financing || {}
    prepareObjDataLayer.conversion.financing = {
      ...prepareObjDataLayer.conversion.financing,
      simulationID: simulation ? simulation.uuid : undefined,
      errorDescription,
      errorID,
      entryValue: simulation ? simulation.downPayment : undefined,
      releasedValue: simulation ? simulation.releasedValue : undefined,
      installmentValue: simulation ? simulation.installmentValue : undefined,
      installmentNumber: simulation ? simulation.installmentAmount : undefined,
      optin: {
        carDelivery: CARDELIVERY_TYPE.NO,
        interest: leadSeeInstallments ? INTEREST_TYPE.YES : INTEREST_TYPE.NO,
        offers: newsletter ? OFFERS_TYPE.YES : OFFERS_TYPE.NO,
      },
    }

    objDataLayer = { ...objDataLayer, ...prepareObjDataLayer }
  }

  const updateObjDatalayerError = cookie => {
    const prepareObjDataLayer = objDataLayer || {}
    prepareObjDataLayer.conversion = prepareObjDataLayer.conversion || {}
    prepareObjDataLayer.conversion.financing =
      prepareObjDataLayer.conversion.financing || {}
    prepareObjDataLayer.conversion.financing = {
      ...prepareObjDataLayer.conversion.financing,
      simulationID: cookie?.error?.data?.Result?.uuid || undefined,
      errorDescription:
        cookie.error.data.Messages[0] || cookie.data.Message || undefined,
      errorID: cookie.error.data.StatusCode || cookie.error.status || undefined,
      entryValue: cookie.simulation.downPayment || undefined,
      releasedValue: cookie.simulation.releasedValue || undefined,
      installmentValue: cookie.simulation.installmentValue || undefined,
      installmentNumber: cookie.simulation.installmentAmount || undefined,
      optin: {
        carDelivery: CARDELIVERY_TYPE.NO,
        interest: cookie.leadSeeInstallments
          ? INTEREST_TYPE.YES
          : INTEREST_TYPE.NO,
        offers: newsletter ? OFFERS_TYPE.YES : OFFERS_TYPE.NO,
      },
    }

    objDataLayer = { ...objDataLayer, ...prepareObjDataLayer }
  }

  const setDataForDataLayer = ({ customer, identification, simulation }) => {
    const hasDataLayer = JSON.parse(localStorage.getItem('WMLoanDataLayer'))
    const entryValue = { value: simulation.downPayment }
    const releasedValue = { value: simulation.releasedValue }
    const installmentValue = { value: simulation.installmentValue }
    const dataLayerDealer = objDataLayer.dealer
      ? {
          ...objDataLayer.dealer,
          type: {
            ...objDataLayer.dealer.type,
            id: identification.request.TipoPessoa.toString(),
            name:
              identification.request.TipoPessoa === PERSON_TYPE.PF
                ? 'pf'
                : 'pj',
            nameDetail:
              identification.request.TipoPessoa === PERSON_TYPE.PF
                ? 'pessoa-fisica'
                : 'loja/concessionaria',
          },
        }
      : null
    let dataLayer = {}
    const objDataLayerLP = {
      ...objDataLayer,
      user: {
        ...objDataLayer.user,
        birthDate: customer.birthday,
        santanderAccount: identification.response.atxResponse.fees.tcExemption
          ? '1'
          : '2',
      },
      dealer: dataLayerDealer,
      conversion: {
        ...objDataLayer.conversion,
        financing: {
          ...objDataLayer.conversion.financing,
          simulationID: simulation.uuid,
          entryValue,
          releasedValue,
          installmentValue,
          priceTable: identification.response.atxResponse.priceTable,
          installmentNumber: simulation.installmentAmount,
          coupon: {
            elegible: false,
          },
        },
      },
    }

    !hasDataLayer
      ? (dataLayer = { ...objDataLayerLP })
      : (dataLayer = { ...hasDataLayer.dataLayer, ...objDataLayerLP })

    window.localStorage.setItem(
      'WMLoanDataLayer',
      JSON.stringify({ dataLayer: { ...dataLayer } })
    )
  }

  const trackingEvents = event => {
    const { env, redirectSimulationWithNoFipe } = config.abTest
    const abTestKeys = EVENT_AB_TEST_KEYS[event]
    const isRedirectSimulationWithNoFipeEvent = event === 'erro_simulacao_financiamento_sem_fipe'

    if (isRedirectSimulationWithNoFipeEvent) {
      const mboxRedirectSimulationWithNoFipe = `${redirectSimulationWithNoFipe.mboxName}-${env}`
      targetApi({
        mboxes: [
          {
            name: mboxRedirectSimulationWithNoFipe,
            keys: redirectSimulationWithNoFipe.key,
          },
        ],
        env,
      })
    }

    if (abTestKeys) {
      abTestKeys.forEach(abTestKey => {
        const { mboxName, key } = config.abTest[abTestKey]

        targetApi({
          mboxes: [{ name: `${mboxName}-${env}`, keys: key }],
          env,
        })
      })
    }

    if (PAGE_INTERACTION_EVENTS.includes(event)) {
      sendPageInteraction(event)
      return
    }

    if (objDataLayer.site) sendDispatchEvent(event)
  }

  const trackingCookies = cookie => {
    if (cookie.error) {
      updateObjDatalayerError(cookie)
    } else if (
      cookie.customer &&
      cookie.simulation.response &&
      cookie.identification.response
    ) {
      blackFair.init(cookie.leadSeeInstallments)

      updateObjDatalayer({
        leadSeeInstallments: cookie.leadSeeInstallments,
        simulation: cookie.simulation.response,
      })
      setDataForDataLayer({
        customer: cookie.customer,
        identification: cookie.identification,
        simulation: cookie.simulation.response,
      })
      createCookieBig(
        COOKIES.CONTINUE_FINANCING,
        { service: cookie },
        EXPIRE_TIME
      )
    }
  }

  const seeConditions = async () => {
    const sellerTypeName = 'aprovacao'
    const utmContent = `simular-anuncio-continuarsantander-${sellerType.toLowerCase()}`
    const { env } = config.abTest

    const urlContinueSantander = createUrlIdc(
      `${config.urlFinancig}${sellerTypeName}/`,
      undefined,
      'financiamento',
      utmContent
    )

    const utmParams =
      '&utm_medium=calhau' +
      '&utm_source=webmotors' +
      '&utm_campaign=financiamento' +
      `&utm_content=${utmContent}`

    sendDispatchEvent('financiamento-detalhe')
    //@TODO: Remover quando finalizar o teste A/B ou internalizar
    // Novo comportamento para teste A/B, onde o usuário que estiver no grupo B irá ser redirecionado diretamente para o Santander, e o grupo A irá continuar com o comportamento legado de abrir em uma nova aba e recarregar a página atual
    const skipSimulationURL = `${urlContinueSantander}${utmParams}&financingSimulationSuccess=true`
    const skipSimulationVariation = localStorage.getItem(`${env}_simulacao_para_proposta_financiamento`)

    if (skipSimulationVariation === 'B') {
      await new Promise(resolve => setTimeout(resolve, 300))
      window.location.assign(skipSimulationURL)
      return
    }

    // Comportamento legado para quem já tinha a simulação feita antes do teste A/B, para não perder as conversões
    window.open(urlContinueSantander, '_blank')
    window.location.reload(true)
  }

  return (
    <div id="SimulationContainer" className="SimulationContainer">
      <SimulationFlow
        env={process.env.NODE_ENV}
        adId={ad.UniqueId}
        vehicleData={VEHICLE_DATE}
        vehicleDetails={VEHICLE_DETAILS}
        announcementData={ANNOUNCEMENT_DATA}
        storeData={STORE_DATA}
        defaultFormData={getLeadCookie()}
        saveFormDataForParents={createFinancingLeadCookie}
        trackingEvents={trackingEvents}
        trackingCookie={trackingCookies}
        seeConditions={seeConditions}
        preFetchVehicleEnabled
      />

      {blackFair.renderModal(getLeadCookie().email)}
    </div>
  )
}

export default SimulationSantanderLib
